import { Phone, Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { trackPhoneClick, trackCTAClick } from "@/lib/analytics";
import { BUSINESS_INFO } from "@/lib/constants";

const MobileActionBar = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden">
      <div className="bg-background/95 backdrop-blur-md border-t shadow-luxury">
        <div className="flex items-center gap-3 px-4 py-3">
          <Button
            variant="outline"
            size="lg"
            className="flex-1"
            asChild
            data-gtm-category="mobile_action_bar"
            data-gtm-action="click_call"
            data-gtm-label="Mobile Bar - Call Now"
          >
            <a 
              data-gtm-id="mobile-actionbar-call-click"
              href={`tel:${BUSINESS_INFO.phone.tel}`}
              className="flex items-center justify-center gap-2"
              onClick={() => trackPhoneClick('mobile_action_bar')}
            >
              <Phone className="h-5 w-5" />
              Call Now
            </a>
          </Button>
          <Button
            variant="default"
            size="lg"
            className="flex-1"
            asChild
            data-gtm-category="mobile_action_bar"
            data-gtm-action="click_book_now"
            data-gtm-label="Mobile Bar - Book Now"
          >
            <Link 
              data-gtm-id="mobile-actionbar-book-now-click"
              to="/booking" 
              className="flex items-center justify-center gap-2"
              onClick={() => trackCTAClick('Book Now', 'mobile_action_bar', '/booking')}
            >
              <Calendar className="h-5 w-5" />
              Book Now
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileActionBar;